// src/i18n/locales/en/shoppingList.ts

export const shoppingList = {
  // Page Header
  title: 'Shopping List',
  subtitle: 'Your personal shopping list for this week',
  daySubtitle: 'Shopping list for Day {{day}}',

  // Day section headers
  dayHeader: 'Day {{day}}',
  dayHeaderUnassigned: 'Other Items',

  // View Mode Dropdown
  viewMode: {
    next7Days: 'Next 7 Days',
    allItems: 'All Items',
  },

  // Subtitle Variations
  subtitleVariations: {
    default: 'Your ingredients for this plan',
    daysRangeWithCount: 'Showing Day {{start}}-{{end}} • {{count}} items',
    allDays: 'Showing All Days • {{count}} items',
  },

  // Confirmation Messages
  confirmDeleteAll: 'Are you sure you want to delete all items from the shopping list?',

  // Mode Toggle (VIP only)
  modeToggle: {
    label: 'Shopping Mode',
    simpleList: 'Simple List Mode',
    smartShopping: 'Smart Shopping',
    locked: 'Smart Shopping is disabled by admin',
  },

  // Stats Cards
  stats: {
    totalItems: 'Total Items',
    completed: 'Completed',
    open: 'Open',
    estimatedPrice: 'Estimated Total',
    items: 'items',
    of: 'of',
  },

  // Action Buttons
  actions: {
    addProduct: 'Add Product',
    deleteCompleted: 'Delete Completed',
    deleteAll: 'Delete All',
    noCompleted: 'No completed items',
    emptyList: 'List is empty',
    exportPDF: 'Export PDF',
    completedCount: '{{count}} completed items',
  },

  // Categories
  categories: {
    all: 'All Items',
    protein: 'Protein',
    meat: 'Meat',
    poultry: 'Poultry',
    fish: 'Fish',
    seafood: 'Seafood',
    vegetables: 'Vegetables',
    fruits: 'Fruits',
    dairy: 'Dairy',
    grains: 'Grains',
    bread: 'Bread & Bakery',
    condiments: 'Condiments & Spices',
    snacks: 'Snacks',
    miscellaneous: 'Miscellaneous',
    Protein: 'Protein',
    Vegetables: 'Vegetables',
    Dairy: 'Dairy',
    Bread: 'Bread & Bakery',
    Fruits: 'Fruits',
    Grains: 'Grains & Pasta',
    Condiments: 'Condiments & Spices',
    Snacks: 'Snacks',
    Miscellaneous: 'Other',
  },

  // Item Card
  item: {
    approximately: 'approx.',
    estimated: 'estimated',
    buyNow: 'Buy Now',
    remove: 'Remove',
    edit: 'Edit',
  },

  // Add Item Modal
  addModal: {
    title: 'Add Product',
    subtitle: 'Add a new item to your shopping list',

    fields: {
      name: {
        label: 'Product Name',
        placeholder: 'e.g., Organic Oatmeal',
        required: 'Product name is required',
      },
      quantity: {
        label: 'Quantity',
        placeholder: 'e.g., 500g or 2 pieces',
        required: 'Quantity is required',
      },
      category: {
        label: 'Category',
        placeholder: 'Select category',
      },
      price: {
        label: 'Estimated Price (optional)',
        placeholder: 'e.g., 3.95',
      },
      supermarket: {
        label: 'Supermarket (VIP)',
        placeholder: 'Select supermarket',
      },
    },

    supermarkets: {
      migros: 'Migros',
      coop: 'Coop',
      aldi: 'Aldi',
      denner: 'Denner',
      lidl: 'Lidl',
    },

    buttons: {
      cancel: 'Cancel',
      add: 'Add to List',
      adding: 'Adding...',
    },
  },

  // Confirmation Modals
  confirmDelete: {
    completed: {
      title: 'Delete Completed Items?',
      message: 'This will remove {{count}} completed item(s) from your list.',
      confirm: 'Yes, Delete',
      cancel: 'Cancel',
    },
    all: {
      title: 'Delete All Items?',
      message: 'This will remove all {{count}} item(s) from your shopping list. This action cannot be undone.',
      confirm: 'Yes, Delete All',
      cancel: 'Cancel',
    },
  },

  // Empty States
  empty: {
    title: 'Your shopping list is empty',
    titleDay: 'No items for Day {{day}}',
    titleDays: 'No items for these days',
    subtitle: 'Add items manually or from recipes',
    addButton: 'Add Your First Item',
    fromRecipe: 'Or browse recipes to add ingredients',
  },

  // Toast Messages
  toast: {
    itemAdded: 'Item added to shopping list',
    itemRemoved: 'Item removed',
    itemsCleared: '{{count}} item(s) removed',
    listCleared: 'Shopping list cleared',
    quantityUpdated: 'Updated {{name}} quantity to {{quantity}}',
    alreadyInList: 'Already in your shopping list',
    ingredientAdded: '{{name}} added to shopping list',
    ingredientsAdded: '{{added}} ingredient(s) added, {{updated}} quantities updated',
    allInList: 'All ingredients already in your list',
    errorAdding: 'Failed to add item',
    errorRemoving: 'Failed to remove item',
    errorLoading: 'Failed to load shopping list',
  },

  // Info Messages
  info: {
    simpleMode: 'Shows only product names and quantities with estimated prices.',
    smartMode: 'Shows real product cards from Migros/Coop with exact prices and "Buy Now" buttons.',
    vipRequired: 'Smart Shopping mode is only available for VIP members',
    adminDisabled: 'Smart Shopping is currently disabled by the administrator',
  },
};